import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to automatically persist workspace mode based on current route
 */
export const useWorkspacePersistence = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Determine workspace mode from path
    let newMode: string | null = null;
    if (currentPath.includes('/workspace/talent/')) {
      newMode = 'talent';
    } else if (currentPath.includes('/workspace/company/')) {
      newMode = 'company';
    } else if (currentPath.includes('/workspace/recruiter/')) {
      newMode = 'recruiter';
    } else if (currentPath.includes('/workspace/internal/')) {
      newMode = 'internal';
    } else if (currentPath.includes('/workspace/nanny/')) {
      newMode = 'nanny';
    } else if (currentPath.includes('/workspace/mother/')) {
      newMode = 'mother';
    }
    
    // Only update localStorage if mode actually changed (prevents unnecessary writes)
    if (newMode) {
      const currentMode = localStorage.getItem('workspace_mode');
      if (currentMode !== newMode) {
        console.debug('[WorkspacePersistence] Mode change:', { 
          from: currentMode, 
          to: newMode, 
          path: currentPath,
          timestamp: Date.now()
        });
        localStorage.setItem('workspace_mode', newMode);
      }
    }
  }, [location.pathname]);
};